<template>
    <div class="animated fadeIn">
        <b-card>
            <h5 class="mb-0"><i class="fa fa-fw fa-pencil mr-2" />Input Barang Masuk</h5>
            <hr />
            <b-row align-v="center">
                <b-col md="4">
                    <b-form-group label="IMEI / No. Faktur PGI">
                        <b-input-group>
                            <b-input id="input-imei-no-faktur" v-model="number" maxlength="60" @keydown.enter="searchNumber" />
                            <b-input-group-append>
                                <b-button id="search-button" variant="primary" @click="searchNumber" :disabled="isSubmitting">
                                    <i class="fa fa-fw fa-search mr-2" />Cari
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="isExternalBarangMasuk" id="external-barang-row">
                <b-col md="4" id="external-barang-col">
                    <b-button class="my-auto" variant="primary" @click="showBarangExternal" id="external-barang-button">
                        <i class="fa fa-fw fa-plus mr-2" />Barang External
                    </b-button>
                    <div id="external-barang-note">
                        <small class="text-muted ml-2">*Tambah barang masuk dari external</small>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-modal id="m-detail" title="Detail Barang" size="xl" no-close-on-backdrop no-close-on-esc hide-footer>
            <DetailBarang :inventoryId="inventoryId" @approved="onApproved" @lost="processLostItem" />
        </b-modal>
        <b-modal id="m-faktur-hp" title="Input No. Faktur" centered no-close-on-backdrop hide-footer>
            <b-form-group label="No. Faktur : " id="form-group-no-faktur">
                <b-input-group id="input-group-no-faktur">
                    <b-input v-model="noFaktur" maxlength="60" id="input-no-faktur" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right" id="button-group-no-faktur">
                <b-button variant="primary" :disabled="isSubmitting" @click="searchNoFaktur" id="search-no-faktur-button">
                    <i class="fa fa-fw fa-search mr-2" />Cari
                </b-button>
            </div>
        </b-modal>

        <ModalInputBarangMasukExternal ref="modalInputBarangMasukExternal" />

        <b-modal id="m-duplicate-imei" title="Pilih Inventaris" size="xl" no-close-on-backdrop no-close-on-esc
            hide-footer>

            <b-table id="duplicate-imei-table" responsive striped hover :items="arrDuplicateImei" :fields="fields">
                <template v-slot:cell(no_faktur)="{ item }">
                    <strong id="no-faktur-cell" style="cursor: pointer;">
                        {{ item.no_faktur }}

                        <b-button id="search-duplicate-imei-button" @click="searcNoDuplicateImei(item)" variant="primary" size="sm">
                            <i class="fa fa-fw fa-search" />
                        </b-button>
                    </strong>
                </template>

                <template v-slot:cell(barang)="{ item }">
                    <strong id="barang-cell">{{ item.type || "-" }}</strong>
                    <div>
                        {{ item.kind || "-" }} - {{ item.brand || "-" }}
                    </div>
                </template>

                <template v-slot:cell(delivery)="{ item }">
                    <div id="delivery-cell">
                        {{ item.source || "-" }} - {{ item.branch || "-" }}
                        <div>
                            {{ $helper.parseDate(item.delivery_date) || "-" }}
                        </div>
                    </div>
                </template>

                <template v-slot:cell(status)="{ item }">
                    <b-badge id="status-badge" :variant="parseStatusVariant(item.status)">
                        {{ parseStatusName(item.status) }}
                    </b-badge>
                </template>
            </b-table>

        </b-modal>


    </div>
</template>

<script>
import DetailBarang from './DetailBarang.vue'
import ModalInputBarangMasukExternal from './ModalInputBarangMasukExternal.vue'
import EnumPermissions from '@/shared/enum-permissions'
import helper from '@/helper'

export default {
    components: {
        DetailBarang,
        ModalInputBarangMasukExternal
    },
    data() {
        return {

            isSubmitting: false,
            inventoryId: null,

            number: "",
            noFaktur: "",

            arrDuplicateImei: "",

            fields: [
                { key: 'no_faktur', label: 'No Faktur', sortable: true },
                { key: 'barang', label: 'Barang', sortable: true },
                { key: 'status', label: 'Status', sortable: true },
                { key: 'delivery', label: 'Pengiriman', sortable: true },
            ],

        }
    },

    computed: {
        isExternalBarangMasuk() {
            return helper.checkRoleNumber(EnumPermissions.CREATE_EXTERNAL_INVENTORY.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },
    },
    methods: {

        searcNoDuplicateImei(item) {
            this.inventoryId = item.id
            this.$bvModal.hide("m-duplicate-imei")
            this.$bvModal.show("m-detail")
        },

        duplicateImeiFetch(imei) {
            this.$axios.get("delivery/inventory/doubleimei", {
            params: { imei_sn: imei }
            }).then(res => {
            this.arrDuplicateImei = res.data.data

            this.$bvModal.show("m-duplicate-imei")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        searchNumber() {

            if (this.isSubmitting) return

            this.isSubmitting = true
            this.$axios.get("inventory/get-id-by-no-faktur-for-input?number=" + this.number).then(res => {

                if (res.data.data.duplicateImei) {
                    this.noFaktur = ""
                    this.duplicateImeiFetch(this.number)
                } else {
                    this.$bvModal.show("m-detail")
                    this.inventoryId = res.data.data.id
                }

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        searchNoFaktur() {

            if (this.isSubmitting) return

            this.isSubmitting = true
            this.$axios.get("inventory/get-id-by-no-faktur-for-input?bypassImei=true&number=" + this.noFaktur).then(res => {

                this.inventoryId = res.data.data.id
                this.$bvModal.show("m-detail")

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        onApproved() {

            this.$bvModal.hide("m-detail")
            this.$bvModal.hide("m-faktur-hp")
            this.$helper.toastSuccess(this, "IMEI/No.Faktur " + this.number + " berhasil diapprove!")
            this.number = ""
            this.noFaktur = ""

        },

        processLostItem() {

            this.$bvModal.hide("m-detail")
            this.$bvModal.hide("m-faktur-hp")
            this.$helper.toastSuccess(this, "IMEI/No.Faktur " + this.number + " berhasil dinyatakan hilang!")
            this.number = ""
            this.noFaktur = ""

        },

        showBarangExternal() {
            this.$refs.modalInputBarangMasukExternal.$bvModal.show('m-input-barang-masuk-external')
        },

        parseStatusVariant(status) {

            switch (status) {
                case 1: return "warning"
                case 2: return "success"
                case 5: return "danger"
                default: return "light"
            }

        },

        parseStatusName(status) {

            switch (status) {
                case 1: return "PENDING"
                case 2: return "APPROVED"
                case 5: return "HILANG"
                default: return "LAINNYA"
            }

        },

    }
}
</script>
